export const INCOME_COLLECTION_CONFIRMED_PREFIX =
    '[income-collection-confirmed]';

export type IncomeCollectionType =
    | 'monthly-take-home'
    | 'yearly-salary'
    | 'custom';

export interface IncomeCollectionConfirmedPayload {
    incomeType: IncomeCollectionType;
    /** Dollar amount from the slider (monthly or yearly). Null for custom. */
    value: number | null;
    /** Free-form text when the member chose the custom option. Null otherwise. */
    text: string | null;
}

export const buildIncomeCollectionConfirmedMessage = ({
    displayText,
    payload,
}: {
    displayText: string;
    payload: IncomeCollectionConfirmedPayload;
}): string =>
    `${displayText}\n${INCOME_COLLECTION_CONFIRMED_PREFIX} ${JSON.stringify(payload)}`;

export const parseIncomeCollectionConfirmedMessage = (
    text: string,
): IncomeCollectionConfirmedPayload | null => {
    const prefixIndex = text.indexOf(INCOME_COLLECTION_CONFIRMED_PREFIX);
    if (prefixIndex === -1) {
        return null;
    }

    const jsonPayload = text
        .slice(prefixIndex + INCOME_COLLECTION_CONFIRMED_PREFIX.length)
        .trim();

    try {
        const parsed: unknown = JSON.parse(jsonPayload);
        if (
            typeof parsed !== 'object' ||
            parsed == null ||
            !('incomeType' in parsed)
        ) {
            return null;
        }
        return parsed as IncomeCollectionConfirmedPayload;
    } catch {
        return null;
    }
};
